"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.SpinnerImageContainer = exports.LoaderMessage = exports.LoaderContainer = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Spinner = _interopRequireDefault(require("../Icons/obsolete/Spinner"));

var _tokens = _interopRequireDefault(require("../Tokens/tokens"));

var _utils = require("../utils");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var font = _tokens.default.font;

var LoaderContainer = _styledComponents.default.div.withConfig({
  displayName: "LoaderContainer",
  componentId: "sc-1hi7djn-0"
})(["text-align:center;position:relative;max-width:", ";"], (0, _utils.pxToRem)(500));

exports.LoaderContainer = LoaderContainer;

var SpinnerImageContainer = _styledComponents.default.div.withConfig({
  displayName: "SpinnerImageContainer",
  componentId: "sc-1hi7djn-1"
})(["text-indent:100%;overflow:hidden;width:100%;height:", ";", "{position:absolute;top:0;transform:translateX(-50%);left:50%;width:", ";height:", ";}"], (0, _utils.pxToRem)(70), _Spinner.default, (0, _utils.pxToRem)(70), (0, _utils.pxToRem)(70));

exports.SpinnerImageContainer = SpinnerImageContainer;

var LoaderMessage = _styledComponents.default.p.withConfig({
  displayName: "LoaderMessage",
  componentId: "sc-1hi7djn-2"
})(["margin:", ";", ";"], (0, _utils.getSpacing)([10, 0, 0]), function (props) {
  return props.fullPage && (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n        font-size: ", ";\n        font-weight: ", ";\n    "])), (0, _utils.pxToRem)(font.size.xxl), font.weight.bold);
});

exports.LoaderMessage = LoaderMessage;